import React from "react";
import { bool, shape } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import CustomText from "pages/_components/CustomText/CustomText";
import { echeqPropTypes } from "pages/echeck/echeckPropTypes";
import FormattedDate from "pages/_components/FormattedDate";
import FormattedAmount from "pages/_components/FormattedAmount";
import InfoTag from "pages/echeck/components/InfoTag";
import { getStatusTagColor } from "util/discounts";
import * as i18n from "util/i18n";
import getCellPlacement from "../../../../util/helpers/table";
import CustomData from "../../../_components/CustomData/CustomData";

const VendorDiscountsItem = ({ isDesktop, recibedDiscounts, showStatus }) => {
    const [cuit, receivedBy] = recibedDiscounts?.receivedBy?.split("\n") || [];
    const alignX = isDesktop ? "center" : "left";
    const alignY = isDesktop ? "center" : "start";
    const getCellProps = (row, col) => getCellPlacement(row, col, { isDesktop });
    const statusLabel = i18n.get(
        recibedDiscounts?.status === "FINISHED"
            ? "transactionLine.discount.status.REJECTED"
            : `transactionLine.discount.status.${recibedDiscounts?.status}`,
    );

    return (
        <>
            <GridTable.Data columnStart={1} alignX="left" rowStart={1}>
                <CustomData
                    titleText="detail.discounts.recibedTo"
                    titleTextType="I18N"
                    valueText={
                        <div className="text-left">
                            <CustomText text={cuit} textType="TEXT" />
                            <br />
                            <CustomText text={receivedBy} textType="TEXT" />
                        </div>
                    }
                    valueTextType="TEXT"
                />
            </GridTable.Data>

            <GridTable.Data alignX={alignX} alignY={alignY} rowWidth={1} {...getCellProps(1, 2)}>
                <CustomData
                    titleText="detail.discounts.idEcheq"
                    titleTextType="I18N"
                    valueText={recibedDiscounts?.echeqNumber}
                    valueTextType="TEXT"
                />
            </GridTable.Data>

            <GridTable.Data alignX={alignX} alignY={alignY} rowWidth={1} {...getCellProps(1, 3)}>
                <CustomData
                    titleText="detail.discounts.emitter"
                    titleTextType="I18N"
                    valueText={<FormattedDate date={recibedDiscounts?.dateEmitted} format="DD/MM/YYYY" />}
                    valueTextType="TEXT"
                />
            </GridTable.Data>

            <GridTable.Data alignX={isDesktop ? "end" : "left"} alignY={alignY} rowWidth={1} {...getCellProps(1, 4)}>
                <CustomData
                    titleText="detail.discounts.amount"
                    titleTextType="I18N"
                    valueText={
                        <FormattedAmount
                            currency={recibedDiscounts?.amount?.currency}
                            quantity={recibedDiscounts?.amount?.quantity}
                        />
                    }
                    valueTextType="TEXT"
                />
            </GridTable.Data>

            {!!showStatus && (
                <GridTable.Data
                    alignX={isDesktop ? "end" : "left"}
                    alignY={alignY}
                    rowWidth={1}
                    {...getCellProps(1, 5)}>
                    <InfoTag
                        type="info"
                        message={statusLabel}
                        tagBackground={getStatusTagColor(recibedDiscounts?.status)}
                        tagClass="discounts-echeq-tag__status"
                    />
                </GridTable.Data>
            )}
        </>
    );
};

VendorDiscountsItem.propTypes = {
    recibedDiscounts: shape(echeqPropTypes).isRequired,
    showStatus: bool.isRequired,
    isDesktop: bool.isRequired,
};

export default VendorDiscountsItem;
